// extracted by mini-css-extract-plugin
export var container = "styles-module--container--7iIk1";
export var futurecontainer = "styles-module--futurecontainer--+neyu";
export var wrapper = "styles-module--wrapper--HO5vl";
export var xponentcontainer = "styles-module--xponentcontainer--jVABK";